<template>
  <div class="l_alert__accountdelete animation__background">
    <div class="l_alert__panel animation__popup">
      <div class="container">
        <div class="description">
          <p>アカウントを<br>削除してよろしいですか？
</p>
        </div>
        <div class="footer">
          <button @click="tapCancel">いいえ</button>
          <button @click="tapUse">はい</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertAccountdelete',
  methods: {
    tapUse() {
      this.$emit('sendDelete')
    },
    tapCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.l_alert__accountdelete {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_alert__panel {
  width: 270px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%,
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.l_alert__accountdelete .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-around;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background-color: #ffffff;
  padding-top: 10px;
}

.l_alert__accountdelete .container .description {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #333333;
  padding: 15px 0 0;
}

.l_alert__accountdelete .container .footer {
  padding-top: 25px;
  width: 100%;
}

.l_alert__accountdelete .container .footer button {
  font-family: 'HiraKakuPro-W3';
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  background-color: #ffffff;
  color: #602209;
  width: 50%;
  padding: 12px 0px;
  outline: none;
}

.l_alert__accountdelete .container .footer button:nth-child(1) {
  border: none;
  border-top: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-radius: 0 0 0 20px;
}

.l_alert__accountdelete .container .footer button:nth-child(2) {
  border: none;
  border-top: 1px solid #eeeeee;
  border-radius: 0 0 20px 0;
}
</style>
